import Cookies from 'js-cookie';

export function closeMenu()
{
	let canvas = $('#navCanvas');
	let body = $('body');
	let burger = $('.menu-trigger');

	body.removeClass('menu-active');
	burger.attr('aria-expanded', false);
	canvas.attr('aria-hidden', true);

	scroll({
		top: 0,
		behavior: 'smooth',
	});
}

/**
 * Sets up a click event
 */
export function setupMenuTrigger()
{
	let canvas = $('#navCanvas');
	let body = $('body');
	let burger = $('.menu-trigger');
	
	burger.on('click', function ()
	{	
		body.removeClass('announcement-active');

		if(body.hasClass('menu-active'))
		{
			body.removeClass('menu-active');
			burger.attr('aria-expanded', false);
			canvas.attr('aria-hidden', true);
		}
		else
		{
			body.addClass('menu-active');
			burger.attr('aria-expanded', true);
			canvas.attr('aria-hidden', false);
		}
	});

	body.on('keyup', function (event) {
		if (body.hasClass('menu-active')) {
			if (event.keyCode == 27) {
				// Close the modal/menu
				body.removeClass('menu-active');
				canvas.attr('aria-hidden', true);

				burger.attr('aria-expanded', false);
				burger.focus();
			}
		}
	});
}

export function childMenuToggle() {
	let childMenuTriggers = document.querySelectorAll('.menu-sidebar__submenu-button');
	if (!childMenuTriggers || childMenuTriggers.length <= 0) {
		return;
	}

	childMenuTriggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			let id = trigger.getAttribute('aria-controls');

			// toggle status of trigger 
			trigger.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') === 'true' ? false : true);

			// toggle status of menu. 
			let menu = document.getElementById(id);
			menu.setAttribute('aria-hidden', menu.getAttribute('aria-hidden') === 'true' ? false : true);
		});
	});

	// reset child menu on swup page change
	document.addEventListener('swup:contentReplaced', () => {
		resetChildMenu(childMenuTriggers); 
	});

	// reset child menu on main menu close 
	let burgerMenu = document.querySelector('.burger-menu');
	burgerMenu.addEventListener('click', () => {
		resetChildMenu(childMenuTriggers); 
	});
}

function resetChildMenu(childMenuTriggers) {
	
	if (!childMenuTriggers || childMenuTriggers.length <= 0) {
		return;
	}
	
	childMenuTriggers.forEach((trigger) => {
		trigger.setAttribute('aria-expanded', false);

		let id = trigger.getAttribute('aria-controls');
		let menu = document.getElementById(id);
		menu.setAttribute('aria-hidden', true);
	});
}

/**
 * Updates the menu based on the current url
 */
export function updateMenu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;

	//Remove the old current page attributes
	let current_page = $('.nav li.current-menu-item');
	current_page.removeClass('current-menu-item').find('a').attr('aria-current', '');

	//Find the new current page and add classes
	let active_items = $('.nav').find('a[href="' + url + '"]');
	active_items.each(function(){
		$(this).attr('aria-current', 'page');
		$(this).parent().addClass('current-menu-item');
	});
}

export function setupAnnouncmentBar()
{
	const announcementBar = document.querySelector('.announcement-bar');
	const body = document.body;

	/*
	 * Doesn't Exist
	 */
	if (
		!announcementBar
		|| announcementBar.length <= 0
		|| Cookies.get('site-visited')
	) {
		return
	}

	setTimeout(() => {
		Cookies.set('site-visited', true, { expires: 1 });
		body.classList.add('announcement-active');
	}, 200)
}

export function scrollTop()
{
	const backToTop = document.querySelector('.js-back-to-top');

	if (!backToTop)
	{
		return
	}

	backToTop.addEventListener('click', () => {
		scroll({
			top: 0,
			behavior: 'smooth',
		});
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js